import { FC } from 'react';
import { CardView } from 'components';

const CardViewPage: FC = () => {
  return (
    <div className="h-screen w-screen">
      <CardView />
    </div>
  );
};

export default CardViewPage;
